import * as d3 from 'd3';

let data = [];

function setupGraph() {

    let table = d3.select(".disagreements .content-graph table tbody");

    let tr = table.selectAll("tr")
        .data(data)
        .enter()
        .append("tr");

    tr.append("td").text(function (d, i) {
        return '#' + (i + 1)
    });
    tr.append("td").text(function (d) {
        return d.imdb.film;
    });
    tr.append("td").text(function (d, i) {
        return '#' + (i + 1)
    });
    tr.append("td").text(function (d) {
        return d.rotten.film;
    });
}

function populateTable() {

    let table = d3.select(".disagreements .content-table table tbody");

    let tr = table.selectAll("tr.data")
        .data(data)
        .enter()
        .append("tr")
        .attr("class", "datarow");

    tr.append("td").html(function (d) {
        return d.imdb.film;
    });
    tr.append("td").html(function (d) {
        return d.rotten.film;
    });

}

function loadData(dataDir) {

    d3.csv(dataDir + "disagreement.csv", function (csvData) {
        csvData.forEach(function (d) {

            let obj = {
                imdb: {
                    film: d['imdb film'],
                    score: +d['imdb score']
                },
                rotten: {
                    film: d['rotten tomato film'],
                    score: +d['rotten tomato score']
                }
            };

            data.push(obj);
        });

        populateTable();
        setupGraph();
    });
}

function init(dataDir) {
    loadData(dataDir);
    window.addEventListener("resize", setupGraph);
}


export {init}


// WEBPACK FOOTER //
// ./disagreements.js